import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Form, Button, Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import FloatingLabelInput from "../restaurant/PlaceHolder";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./css/school-address.css";


function OrganizationAddress() {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [search, setSearch] = useState("");
  const [organizationId, setorganizationId] = useState(null);
  const [address, setAddress] = useState({
    organizationId: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    createdById: "",
    updatedById: "",
    lon: "",
    lat: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const organizationId = localStorage.getItem("organizationId");
    if (organizationId) {
      setorganizationId(organizationId)
      fetchAddresses(organizationId)
    }
    // eslint-disable-next-line
  }, [organizationId]);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    console.log("token", token);
    setAuthToken(token);

    if (authToken === false) {
      navigate("/organization/signin"); // Redirect if no token is found
    }
  }, [authToken]); // Add `navigate` to dependencies to avoid stale closure issues

  console.log('id', organizationId);
  const fetchAddresses = async () => {
    try {
      const token = localStorage.getItem("Token");
      setAuthToken(token);
      const response = await axiosOrganizationInstance.get(`/organization-address/${organizationId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Set the token in the Authorization header
        },
      });
      setAddresses(response.data);
      
      console.log("Address", response.data);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  const handleAddressChange = (field, value) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value, // Update the specific field
    }));
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    // console.log(address)
    if (!address.postalCode) {
      alert("Please Enter the correct postal code");
      return;
    }
    if (!address.longitude || !address.latitude) {
      alert("Invalid address please check");
      return;
    }
    try {
      let response;
      if (isEditing && selectedAddress) {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.put(
          `/organization-address/${selectedAddress.addressId}`,
          address,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
        const updatedAddress = response.data;
        setAddresses((prevAddresses) =>
          prevAddresses.map((addr) =>
            addr.addressId === selectedAddress.addressId ? updatedAddress : addr
          )
        );
        alert("Address updated successfully!");
      } else {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.post(
          `/organization_address/${organizationId}}`,
          address,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
        const newAddress = response.data;
        setAddresses((prevAddresses) => [...prevAddresses, newAddress]);
        alert("Address added successfully!");
      }

      fetchAddresses();
      resetForm();
    } catch (error) {
      console.error("Error submitting address:", error);
      alert(
        `Error submitting address: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const handleSelectAddress = (addressId) => {
    const addressToEdit = addresses.find(
      (addr) => addr.addressId === addressId
    );
    if (addressToEdit) {
      setAddress(addressToEdit);
      setSelectedAddress(addressToEdit);
      setIsEditing(true);
      setIsFormVisible(true);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    if (window.confirm("Are you sure you want to delete this address?")) {
      try {
        const token = localStorage.getItem("Token");
        await axiosOrganizationInstance.delete(`/organization_address/${addressId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
          },
        });
        setAddresses((prevAddresses) =>
          prevAddresses.filter((addr) => addr.addressId !== addressId)
        );
        alert("Address deleted successfully!");
      } catch (error) {
        console.error("Error deleting address:", error);
        alert("Error deleting address. Please check the console for details.");
      }
    }
  };

  const resetForm = () => {
    setAddress({
      organizationId: organizationId,
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      createdById: organizationId,
      updatedById: "",
      longitude: "",
      latitude: "",
    });
    setIsEditing(false);
    setSelectedAddress(null);
    setIsFormVisible(false);
  };

  // Handle Address Search
  const handleAddressSearch = async (e) => {
    //   const adrln1 =  e.target.value;
    setSearch(e.target.value);
    if (e.target.value.length > 2) {
      try {
        const response = await axiosOrganizationInstance.get(`/get-address`, {
          params: {
            address: e.target.value,
          },
        });
        setAddressSuggestions(response.data.suggestions || []);
      } catch (error) {
        console.error(
          "Error fetching address suggestions:",
          error.response ? error.response.data : error.message
        );
      }
    } else {
      setAddressSuggestions([]);
    }
  };
  //Address selection

  const handleAddressSelect = async (placeId) => {
    try {
      // Fetch details for the selected address (using Google API or backend service)
      const response = await axiosOrganizationInstance.get(`/get-address-details`, {
        params: { placeId },
      });

      const placeDetails = response.data;

      if (!placeDetails) {
        alert("Address details not found");
        return;
      }

      // Automatically fill in the form fields with the fetched address details
      const adrsline1 = placeDetails.addressLine1 || "";
      const adrsline2 = placeDetails.addressLine2 || "";
      const adrspostal = placeDetails.postalCode || "";
      const adrscity = placeDetails.city || "";
      const adrsstate = placeDetails.state || "";
      const adrsCountry = placeDetails.country || "";
      const adrslat = placeDetails.latitude || "";
      const adrslong = placeDetails.longitude || "";

      const updatedAddress = {
        addressLine1: adrsline1 || address.addressLine1,
        addressLine2: adrsline2 || address.addressLine2,

        city: adrscity || address.city,
        state: adrsstate || address.state,
        postalCode: adrspostal || address.postalCode,
        country: adrsCountry || address.country,
        latitude: adrslat || address.latitude,
        longitude: adrslong || address.longitude,
        organizationId: organizationId,
        createdById: organizationId,
      };

     
      setAddress((prev)=>({...prev, ...updatedAddress}));
      setSelectedAddress((prev)=>({...prev, ...updatedAddress}));
      console.log("Updated organizationDetails:", updatedAddress); // Debugging
     
      setAddressSuggestions([]); // Clear suggestions after selection
      // setSearch("");
    } catch (error) {
      console.error(
        "Error fetching place details:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div className="mt-5" style={{marginLeft:'30px'}}>
      
      <Row>
        <Col lg={12} className="mb-1">
          <div
            className="ag-theme-quartz"
            style={{ height: 400, width: "100%" }}
          >
            <AgGridReact
              columnDefs={[
                {
                  headerName: "Address Line 1",
                  field: "addressLine1",
                  suppressMovable: true,
                  width: "216",
                },
                {
                  headerName: "City",
                  field: "city",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "State",
                  field: "state",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Postal Code",
                  field: "postalCode",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Country",
                  field: "country",
                  suppressMovable: true,
                  width: "150",
                },
                {
                  headerName: "Actions",
                  width: "150",
                  cellRenderer: (params) => {
                    return (
                      isEditing === false && (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ marginTop: "12px" }}
                        >
                          <CiEdit
                            onClick={() =>
                              handleSelectAddress(params.data.addressId)
                            }
                            style={{
                              fontSize: "24px",
                              color: "#017EF3",
                              cursor: "pointer",
                            }}
                          />

                          <MdOutlineDeleteOutline
                            style={{
                              marginLeft: "20px",
                              color: "#FF3B30",
                              cursor: "pointer",
                              fontSize: "24px",
                            }}
                            onClick={() =>
                              handleDeleteAddress(params.data.addressId)
                            }
                          />
                        </div>
                      )
                    );
                  },
                  suppressMovable: true,
                },
              ]}
              rowData={addresses}
              pagination={false}
              paginationPageSize={10}
              domLayout="autoHeight"
            />
          </div>
        </Col>

        {isFormVisible && (
          <Col lg={12} className="mb-4" style={{ marginTop: "-200px" }}>
            <div className="card shadow-box" style={{ border: "none" }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="text-center">
                    {isEditing ? "Edit Address" : "Add New Address"}
                  </h5>
                </div>
                <hr />
                <Form onSubmit={handleAddressSubmit} className="address-form" style={{border:'none'}}>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col
                      md={6}
                      lg={12}
                      className="colum"
                      // style={{ marginBottom: "10px" }}
                    >
                       <Form.Group className="mb-3">
                       <div style={{ display: "flex", alignItems: "flex-start" }}>
              <Form.Label
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#323E4F",
                }}
              ></Form.Label>
              <FloatingLabelInput
                type="text"
                value={search} // Fallback to an empty string if undefined
                onChange={handleAddressSearch}
                label="Search Address" // Correct label for Address Line 2
                isRequired={false} // Make it a required field
                size="sm" // Adjust input size
              />

              {addressSuggestions.length > 0 && (
                <ul
                  className="address-suggestions-dropdown"
                  style={{ marginTop: "50px" }}
                >
                  {addressSuggestions.map((suggestion) => (
                    <li
                      key={suggestion.place_id}
                      onClick={() => handleAddressSelect(suggestion.place_id)}
                    >
                      {suggestion.description}
                    </li>
                  ))}
                </ul>
              )}
            </div>
                       </Form.Group>
                    </Col>
                  </Row>
         
                  <Row>
                   
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Address Line 1
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="addressLine1"
                          value={address.addressLine1}
                          onChange={(e) =>
                            handleAddressChange("addressLine1", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Address Line 2
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="addressLine2"
                          value={address.addressLine2}
                          onChange={(e) =>
                            handleAddressChange("addressLine2", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            City
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="city"
                          value={address.city}
                          onChange={(e) =>
                            handleAddressChange("city", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            State
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="state"
                          value={address.state}
                          onChange={(e) =>
                            handleAddressChange("state", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Postal Code
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="postalCode"
                          value={address.postalCode}
                          onChange={(e) =>
                            handleAddressChange("postalCode", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Country
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="country"
                          value={address.country}
                          onChange={(e) =>
                            handleAddressChange("country", e.target.value)
                          }
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    
                    <Button
                      type="submit"
                      variant="outline-dark"
                      style={{
                        width: "120px",
                        backgroundColor: "#FFFEF0",
                        border: "1px solid #0976A1",
                        color: "#017EF3",
                        marginRight : "10px"
                      }}
                    >
                      {isEditing ? "Save" : "Add Address"}
                    </Button>
                    <Button
                    variant="outline-dark"
                    // size="sm"
                    onClick={resetForm}
                    style={{
                      width: "120px",
                      backgroundColor: "#FFFEF0",
                      border: "1px solid #0976A1",
                      color: "#017EF3",
                    }}
                  >
                    Cancel
                  </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default OrganizationAddress;
